module.exports = __webpack_public_path__ + "static/object-4-83f2e6658cd15896b7a97648f3f51ca0.png";